import { render, staticRenderFns } from "./FOCUSView.vue?vue&type=template&id=f1889a28"
import script from "./FOCUSView.vue?vue&type=script&lang=js"
export * from "./FOCUSView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports